import {
  LOGIN,
  LOGOUT,
} from './mutation-types';

export default {
  [LOGIN](state, user) {
    state.currentUser = user;
  },

  [LOGOUT](state) {
    state.currentUser = undefined;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js